module.exports = __webpack_public_path__ + "/bundle/asset/plan-2-899555cea5c826f27213899a27705a91.png";